<script>
import Vue from 'vue'
import { Restaurants } from '@/api'
import store from '@/modules/store'
import restaurantList from '@/modules/mixins/restaurantList'
import TrackingAlert from '@/components/organism/restaurants/TrackingAlert'
import RestaurantsLoader from '@/components/molecules/RestaurantsLoader.vue'
import BrandHero from '@/components/organism/brand/BrandHero.vue'
import BrandStoreList from '@/components/organism/brand/BrandStoreList.vue'

const restaurants = Vue.observable(new Restaurants())

export default {
    name: 'Brand',

    components: {
        RestaurantsLoader,
        TrackingAlert,
        BrandStoreList,
        BrandHero,
    },

    mixins: [restaurantList],

    computed: {
        restaurants: () => restaurants,
        pageTitle() {
            return this.$t('labels.brands')
        },
        rows() {
            return (this.restaurants.items || []).filter(Boolean)
        },
        brand() {
            return this.rows[0] ? this.rows[0].brand : undefined
        },
        // The brand's own cover wins; the first loaded profile's card image is the fallback.
        heroPhoto() {
            const row = this.rows[0]
            if (!row) return null
            return (this.brand && this.brand.cover) || row.image || null
        },
        storeCount() {
            return new Set(this.rows.filter((row) => row.store).map((row) => row.store.id)).size
        },
    },

    mounted() {
        this.$store.dispatch('getDeliveryPeriod', {
            restaurantId: undefined,
            allowanceId: this.$store.getters['allowance']?.id,
        })
    },
    beforeRouteEnter(to, from, next) {
        restaurantList.methods
            .setList(restaurants, to, {
                brand: to.params.slug,
                address: store.getters['order/address']?.link,
            })
            .finally(() =>
                next((vm) => {
                    vm.$cart.calculate()
                })
            )
        next()
    },
}
</script>

<template lang="pug">
.brand-page-root
    brand-hero(:brand="brand" :photo="heroPhoto" :store-count="storeCount")
    .container.pt-page.pb-page
        brand-store-list(:restaurants="restaurants" :set-list="setList")
        restaurants-loader(:restaurants="restaurants")
        tracking-alert
</template>
